import DoneIcon from '@mui/icons-material/Done';
import React, { useEffect, useState } from "react";
import approvedImage from "../../assets/svg/approved.svg";
import { useSelector } from 'react-redux';
import CustomButton from '../../component/elements/CustomButton/CustomButton';
import { useNavigate } from 'react-router-dom';
import TydiiLoader from '../../tydiiLoader';
import { useSnackbar } from '../../component/SnackbarContext';
import axiosInstance from '../../configuration/request';

const ApprovalScreen = () => {
  const navigate = useNavigate();
  const { approvalDetails } = useSelector((state) => state.counter);
  const { loginDetails } = useSelector((state) => state.counter);
  // const { name = "", email = "", phone_number = "", userType = "" } = approvalDetails || {};
  const [isLoading, setIsLoading] = useState(false);
  const showSnackbar = useSnackbar();
  const [storeDetails, setStoreDetails] = useState({});
  const [accountId, setAccountId] = useState(null);
  const [accountStatus, setAccountStatus] = useState(false);
  const detailsList = [
    { label: "Name", value: loginDetails?.name },
    { label: "Email", value: loginDetails?.email },
    { label: "Phone number", value: loginDetails?.phone_number }
  ];


  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = () => {
    axiosInstance
      .get(`/customer/users?id=${loginDetails?.userId}`)
      .then((res) => {
        let accountID = null
        let data = res?.data?.data[0];
        if (data?.stores && data?.stores.length > 0) {
          setStoreDetails(data?.stores[0]);
          accountID = data?.stores[0]?.stripeAccountId
        } else {
          accountID = data?.deliveryPerson?.stripeAccountId
        }
        setAccountId(accountID)
        if (accountID) {
          fetchAccountStatus(accountID)
        }
      })
      .catch((error) => {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      });
  };

  const fetchAccountStatus = (accountID) => {
    axiosInstance
      .get(`/payment/stripe/status/${accountID}`)
      .then((res) => {
        setAccountStatus(res?.data?.status)
      })
      .catch((error) => {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      });
  };

  const handleBackHome = () => {
    navigate('/')
  };


  const handleStripSetup = () => {
    let payload = {
      email: loginDetails?.email,
      type: loginDetails?.userType === 'business user' ? "store" : 'delivery',
      businessName: loginDetails?.userType === 'business user' ? approvalDetails?.stores[0]?.storeName : '',
      country: "US"
    }
    axiosInstance
      .post(`/payment/stripe/create-account`, payload)
      .then((res) => {
        setIsLoading(true)
        window.location.href = res?.data?.data?.onboardingUrl;
      })
      .catch((error) => {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      });
  };


  const completeStripSetup = () => {

    axiosInstance
      .get(`/payment/stripe/refresh/${accountId}`)
      .then((res) => {
        setIsLoading(true)
        window.location.href = res?.data?.data?.onboardingUrl;
      })
      .catch((error) => {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      });
  };

  return (
    <div className='h-[calc(100vh-80px)] flex items-center justify-center'>
      {isLoading && <TydiiLoader />}
      <div className="h-[calc(100vh-150px)] flex items-end justify-center bg-[#4293C6] rounded-[30px] mx-1 p-2 sm:mx-10 sm:px-16 sm:pt-16 xs:pb-3 ">
        <div className="bg-[#F9FDFF] rounded-[30px] shadow-lg h-full p-10 w-full flex flex-col sm:flex-row items-center justify-center gap-8">

          {/* Left Section */}
          <div className=' w-full xl:w-[40%]'>
            <h2 className="text-2xl font-semibold text-[#222] mb-2">
              Dear {loginDetails?.name || "User"},
            </h2>
            <p className="text-[#222] mb-2">Thank you for registering!</p>
            <p className="text-[#222] mb-6">
              Your request is under review. You'll be notified once approved to access the platform as a{" "}
              {loginDetails?.userType === "delivery user"
                ? "Delivery Partner"
                : loginDetails?.userType === "business user"
                  ? "Business Partner"
                  : loginDetails?.userType}
            </p>

            <ul className="space-y-3 text-[#222] mb-3">
              {detailsList.map((item) => (
                <li key={item.label} className="flex text-[14px] sm:text-base items-center gap-2">
                  <span>• {item.label}: <strong>{item.value}</strong></span>
                  <span className="hidden sm:flex items-center justify-center shadow-md rounded-full bg-[#D1FADF] text-green-700 w-5 h-5 ml-2">
                    <DoneIcon sx={{ fontSize: 14 }} />
                  </span>
                </li>
              ))}
            </ul>

            {accountId ? (<div>{!accountStatus && <div className='text-sm'> Your payout account setup is incomplete. Please finish the verification process.</div>}</div>) : (
              <div className='text-sm'>
                Please set up your payout account to continue.
              </div>
            )}

            <div className='flex gap-3 mt-3'>
              <CustomButton
                customeClass="primary-custom-button w-[180px] h-[40px]"
                onClick={handleBackHome}
              >
                Back to Home
              </CustomButton>

              {accountId ? (
                <div >
                  {!accountStatus &&
                    <CustomButton
                      onClick={completeStripSetup}
                      customeClass="gradient-button w-[200px] h-[40px]"
                    >
                      Continue Account Setup
                    </CustomButton>
                  }

                </div>
              ) : (
                <CustomButton
                  onClick={handleStripSetup}
                  customeClass="gradient-button w-[200px] h-[40px]"
                >
                  Create Payout Account
                </CustomButton>
              )}
            </div>
          </div>

          {/* Right Section */}
          <div className='hidden lg:flex' >
            <img
              src={approvedImage}
              alt="Approval Illustration"
              className="w-full max-w-[600px] mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalScreen;
